<template>
  <b-modal v-model="showPopup"
           :hide-footer="true"
           :no-close-on-backdrop="true"
           :no-close-on-esc="true"
           id="reg-modal"
  >
    <div class="row w-100 mx-0 justify-content-center">
      <h3 class="text-white">Регистрация</h3>
    </div>
    <div class="row mx-0 px-0 px-lg-4">
      <alert :message="response"></alert>
      <b-form class="auth-form mt-3 w-100" @submit.prevent="Login" autocomplete="off">
        <div class="row mx-0">
          <div class="col-12 px-0">
            <input class="form-control input-bg input-bg-login" required v-model="payload.user_login"
                   aria-label="user-login">
            <div class="placeholder">Логин <span class="text-orange">*</span></div>
          </div>
        </div>
        <div class="row mx-0 my-4">
          <div class="col-12 px-0">
            <input class="form-control input-bg input-bg-pass" required type="password"
                   v-model="payload.user_password"
                   aria-label="user-password">
            <div class="placeholder">Пароль <span class="text-orange">*</span></div>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-12 px-0">
            <input class="form-control input-bg input-bg-email" required v-model="payload.user_email"
                   aria-label="user-email">
            <div class="placeholder">E-mail адрес <span class="text-orange">*</span></div>
          </div>
        </div>
        <div class="row mx-0 my-4">
          <div class="col-12 px-0">
            <the-mask :mask="['+#(###)-###-##-##', '+#(###)-###-##-###']" class="form-control input-bg input-bg-phone"
                      v-model="payload.user_phone"
                      required type="text" aria-label="user-phone"></the-mask>
            <div class="placeholder">Номер телефона <span class="text-orange">*</span></div>
          </div>
        </div>

        <div class="row mx-0 my-4">

            <div class="col-6">
              <label class="col-form-label mr-3 text-white">У вас есть промокод?</label>
            </div>
            <div class="col-6">
              <input type="checkbox" v-model="payload.promo_exist" @change="unsetParams" style="height: 45px;">
            </div>

        </div>

        <div class="row mx-0" v-if="payload.promo_exist">
          <div class="col-12 px-0">
            <input class="form-control input-bg input-bg-dot-auth" required v-model="payload.promo_code" aria-label="promo-code">
            <div class="placeholder">Промо-код</div>
          </div>
        </div>

        <div v-else-if="!enabledRegistration"  id="users_referer_area"  >
          <div class="row mx-0">
            <div class="col-12 px-0">
              <input class="form-control input-bg input-bg-login" required v-model="payload.referer_login"  aria-label="referer_login">
              <div class="placeholder">Логин друга <span class="text-orange">*</span></div>
            </div>
          </div>

          <div class="row mx-0 my-4">
            <div class="col-12 px-0">
              <input class="form-control input-bg input-bg-email" required v-model="payload.contact_info"  aria-label="contact_info">
              <div class="placeholder">Ваша контактная информация для связи <span class="text-orange">*</span></div>
            </div>
          </div>
        </div>


        <div class="row mx-0 my-4" v-if="getAdminTgLinks">
            <span class="text-white"> В случае возникновения вопросов, пожалуйста, обращайтесь в
              <a target="_blank" :href="getAdminTgLinks">администрацию сайта через Telegram.</a></span>
        </div>

        <div class="row mx-0 my-4 justify-content-center">
          <button class="btn red-btn px-5 my-3" @click.prevent="Registration" :disabled="isSubmitting">
            Регистрация
          </button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import Alert from '@/components/Alert'

export default {
  components: {
    Alert
  },
  data() {
    return {
      response: null,
      showPopup: false,
      isSubmitting: false,
      payload: {
        user_login: '',
        user_email: '',
        user_password: '',
        user_phone: '',
        promo_code: '',
        user_currency: 1,
        referer_login: '',
        contact_info: '',
        promo_exist: true,
      }
    }
  },
  methods: {
    Registration() {
      this.response = {status: 'loading'}
      this.isSubmitting = true
      let sendData  = this.payload
      if(!this.payload.promo_exist){
        delete sendData.promo_exist
      }
      this.axios.post(
          this.$_config.baseUrl + '/Api/registration',
          sendData, {
            withCredentials: true
          }
      ).then(({data}) => {
        this.isSubmitting = false
        this.response = data
        if (data.status === 'ok') {
          this.$store.dispatch('fetchUserData')
          this.$store.dispatch('getMainSettings')
          this.$store.dispatch('fetchApiData')

          setTimeout(() => {
            if (!this.userData) {
              this.$root.$emit('bv::hide::modal', 'reg-modal')
              window.location.reload()
            }
          }, 5000)
        }
      }).catch((err) => {
        if (err) {
          this.isSubmitting = false
          this.response = {status: 'error', msg: err.response.data.errors}
        }
      })
    },
    unsetParams() {
      this.payload.promo_code = "";
      this.payload.referer_login = "";
      this.payload.contact_info = "";
    }
  },
  computed: {
    userData() {
      return this.$store.getters['userData']
    },
    enabledRegistration(){
      return this.$store.getters.getEnabledRegistration
    },
    getAdminTgLinks() {
      return this.$store.getters.getSocialLinks['site_administration']
    }
  },
  watch: {
    userData(newValue) {
      if (newValue) {
        this.$root.$emit('bv::hide::modal', 'reg-modal')
      }
    }
  },
  mounted() {
    if (this.userData) {
      this.$root.$emit('bv::hide::modal', 'reg-modal')
    }
  }
}
</script>

<style scoped>
.placeholder {
  top: 10px;
  left: 18px;
  font-size: 15px;
}
</style>
